import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
var TAB_KEY = 'Tab';
export var usePreviewStoriesTabNavigation = function usePreviewStoriesTabNavigation() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    previewSwiper = _useState2[0],
    setPreviewSwiper = _useState2[1];
  var handlePressKey = function handlePressKey(event) {
    if (!previewSwiper) {
      return;
    }
    var key = event.key,
      shiftKey = event.shiftKey;
    if (key === TAB_KEY && !shiftKey) {
      previewSwiper.slideTo(previewSwiper.activeIndex + 1);
    }
    if (key === TAB_KEY && shiftKey) {
      previewSwiper.slideTo(previewSwiper.activeIndex - 1);
    }
    hideBulletsForTabNav();
  };
  var hideBulletsForTabNav = function hideBulletsForTabNav() {
    previewSwiper === null || previewSwiper === void 0 ? void 0 : previewSwiper.pagination.bullets.forEach(function (bullet) {
      bullet.tabIndex = -1;
    });
  };
  useEffect(function () {
    if (!previewSwiper) {
      return;
    }
    var swiperElement = previewSwiper.el;
    hideBulletsForTabNav();
    swiperElement.addEventListener('keydown', handlePressKey);
    // eslint-disable-next-line consistent-return
    return function () {
      return swiperElement.removeEventListener('keydown', handlePressKey);
    };
  }, [previewSwiper]);
  return {
    setPreviewSwiper: setPreviewSwiper,
    hideBulletsForTabNav: hideBulletsForTabNav
  };
};